const Styles = () => ({
  header: {
    padding: "14px 20px",
    background: "white",
    borderBottom: "1px solid #dadada",
    height: 61,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  },
  root: {
    width: "100%",
    position: 'absolute',
    top: "2px",
    minHeight: "calc(100vh - 66px)",
    background: "#f9f9f9"
  },
  titleTextEdit: {
    fontSize: 20,
    lineHeight: "30px",
    fontWeight: 600,
    marginLeft: 20
  },
  titleTextName: {
    fontSize: 20,
    lineHeight: "30px",
  },
  leftHeader: {
    display: "flex",
    alignItems: "center"
  },
  rightHeader: {
    display: "flex",
    alignItems: "center"
  },
  buttonStyle: {
    marginLeft: 12,
    textTransform: "none",
    height: 32
  },
  divider: {
    height: 30,
    width: 1,
    background: "rgba(196, 196, 196, 1)",
    marginLeft: "12px"
  },
  emailText: {
    fontSize: 16,
    color: "rgba(51, 51, 51, 1)",
    marginTop: 2,
    marginRight: 5
  },
  iframeBackground: {
    background: "white",
    border: "none",
  },
  iframeContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "25px 20px",
    position: "relative"
  },
  menu: {
    height: 44,
    cursor: "pointer",
    padding: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: 14
  },
  menuContainer: {
    border: "1px solid #dadada",
    background: "white",
    width: 200,
    position: "absolute",
    top: "23px",
    left: "20px",
    fontFamily: "Open Sans"
  },
  rightButtonsContainer: {
    position: "absolute",
    top: "10px",
    right: "20px",
    display: "flex",
    alignItems: "center"
  },
  selectedMenu: {
    background: "rgba(38, 187, 237, 0.06)"
  },
  subMenu: {
    color: "rgba(51, 51, 51, 0.75)"
  },
  subMenuSelected: {
    color: "rgba(0, 0, 0, 1)",
    fontWeight: 600
  },
  iconRotate: {
    transform: "rotate(180deg)"
  },
  subjectInput: {
    background: "rgba(255, 255, 255, 0.8)",
    border: "1px solid #dadada",
    marginBottom: 20,
    height: 50,
    width: "100%"
  },
  subjectLabel: {
    fontWeight: 600,
    fontSize: 18
  },
  rightButtonCSS: {
    fontWeight: 400,
    fontSize: 14,
    textTransform: "none"
  },
  inactiveCSS: {
    color: "rgba(51, 51, 51, 0.5)"
  },
  separator: { height: 30, width: 0, border: "1px solid #EEEEEE", margin: "0 10px" },
  loader: {
    height: "calc(100vh - 177px)"
  }

})


export default Styles

